// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../rescript/lib/es6/curry.js";
import * as React from "react";

function Row(Props) {
  var children = Props.children;
  var classNameOpt = Props.className;
  var on_clickOpt = Props.on_click;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var on_click = on_clickOpt !== undefined ? on_clickOpt : (function (param) {
        
      });
  return React.createElement("div", {
              className: "u-flex__row " + className,
              onClick: (function (param) {
                  return Curry._1(on_click, undefined);
                })
            }, children);
}

var make = Row;

export {
  make ,
  
}
/* react Not a pure module */
